
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiReset as ObiResetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-reset.js';
 
 
 

 
 export const ObiReset = createComponent({
   react: React,
   tagName: 'obi-reset',
   elementClass: ObiResetElement,
   events: {
     
   }
  });
 
 